import client from '@/lib/axios-client'
import type {
	SyncChangeFilters,
	SyncChangeListOutput,
	SyncLogListOutput,
	SyncProtheusResult,
	SyncType,
} from '@/types/sync'

const SYNC_URL = '/sync'

// ── POST /sync/protheus ───────────────────────────────────────────────────────

export async function syncProtheus(): Promise<SyncProtheusResult> {
	const response = await client.post(`${SYNC_URL}/protheus`, {
		type: 'all',
	})
	return response.data.data
}

// ── GET /sync/logs ────────────────────────────────────────────────────────────

export async function getSyncLogs(): Promise<SyncLogListOutput> {
	const response = await client.get(`${SYNC_URL}/logs`)
	const data: SyncLogListOutput = response.data.data

	// normalize syncType casing to lowercase for frontend consistency
	data.items = data.items.map((item) => ({
		...item,
		syncType: (item.syncType || '').toLowerCase() as SyncType,
	}))

	return data
}

// ── GET /sync/logs/:id/changes ────────────────────────────────────────────────

export async function getSyncChanges(
	logId: string,
	filters: SyncChangeFilters,
): Promise<SyncChangeListOutput> {
	const response = await client.get(`${SYNC_URL}/logs/${logId}/changes`, {
		params: filters,
	})
	return response.data.data
}
